import type { SxProps, Theme } from "@mui/material/styles";

/** Matches Ticket Information / dashboard primary — Tickets vs Emails tabs */
export const activitySubTabsSx: SxProps<Theme> = {
  ml: 1,
  "& .MuiTab-root": {
    color: "#1e293b",
    fontWeight: 500,
    textTransform: "none",
    fontSize: "0.9rem",
    minHeight: 42,
    "&.Mui-selected": {
      color: "#6366f1",
      fontWeight: 600,
    },
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "#6366f1",
  },
};